import React from 'react'
import Image from 'next/image'
import styles from './Association.module.scss'
import Marquee from 'react-fast-marquee'

interface LogoItem {
  path: string
  alt: string
}

const logos: LogoItem[] = [
  { path: '/logos/zalon.webp', alt: 'ZALON' },
  { path: '/companyLogo/lal10-new.png', alt: 'LAL 10' },
  { path: '/logos/unicorn.jpg', alt: 'Unicorn' },
  { path: '/logos/symphonyai-color-logo.png', alt: 'Symphony AI' },
  { path: '/logos/native.jpeg', alt: 'NATIVE' },
  { path: '/companyLogo/two-brothers.webp', alt: 'TWO BROTHERS' },
  { path: '/logos/Lawyered.png', alt: 'Lawyered' },
  { path: '/logos/HappyNature.png', alt: 'Happy Nature' },
  { path: '/logos/gray-matters.webp', alt: 'Gray Matters Capital' },
  { path: '/logos/spencer-logo.png', alt: "Spencer's" },
  { path: '/logos/antreas-logo.png', alt: 'Antreas' },
  { path: '/logos/spendng.png', alt: 'Spendng' },
  { path: '/companyLogo/wishbox.webp', alt: 'Wishbox' },
  { path: '/logos/Cybersettle.png', alt: 'CyberSettle' },
  { path: '/logos/multibhashi.jpg', alt: 'Multibhashi' },
]

const Association = () => {
  return (
    <section className={styles['container']}>
      <img
        src='group151.webp'
        alt='background-img'
        className={styles['bg-mobile']}
      />

      <p className={styles['eyebrow']}>Trusted by forward-thinking companies</p>

      <div className={styles['marquee-wrapper']}>
        <Marquee speed={40} pauseOnHover gradient={false}>
          {logos.map((logo) => (
            <div className={styles['logo']} key={logo.alt}>
              <Image
                src={logo.path}
                alt={logo.alt}
                width={180}
                height={64}
                className={styles['logo-img']}
                style={{ objectFit: 'contain' }}
              />
            </div>
          ))}
        </Marquee>
      </div>
    </section>
  )
}

export default Association
